import React, { useMemo } from 'react';

import { useIntl } from 'react-intl';

import { useIsLgDesktopBp } from 'hooks/breakpoints';
import { useLocalizedTabs } from 'navigation/tab-navigator/tabs';
import { region } from 'utils/environment';

import { LeftNav } from './left-nav';

export const LeftNavContainer = () => {
  const { formatMessage } = useIntl();
  const isLgDesktop = useIsLgDesktopBp();
  const localizedTabs = useLocalizedTabs();
  // TODO: in version 8.0.0 this can be changed to use the .ca extension
  const cateringLink =
    region() === 'CA' ? '/order-catering' : 'https://www.ezcater.com/brand/pvt/firehouse-subs';
  const navLinks = useMemo(() => {
    const links = localizedTabs.map(tab => ({ key: tab.id, link: tab.link, text: tab.text }));
    if (isLgDesktop) {
      links.push({
        key: 'catering',
        link: cateringLink,
        text: formatMessage({ id: 'catering' }),
      });
    }

    return links;
  }, [localizedTabs, isLgDesktop, formatMessage]);

  return <LeftNav navLinks={navLinks} />;
};
